import React from 'react'

const Newreceivedorders = () => {
  return (
    <div>
      <h1>handleDisplayOptionChange</h1>
    </div>
  )
}

export default Newreceivedorders
